import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  phoneTitle: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.2,
  },
  upfrontValue: {
    ...Fonts.type.bold,
    lineHeight: 31.2,
    fontSize: 25,
  },
  upfrontTitle: {
    lineHeight: 25,
    marginLeft: 4,
    fontSize: 18.7,
  },
  monthlyValue: {
    ...Fonts.type.bold,
    lineHeight: 31.2,
    marginLeft: 16,
    fontSize: 25,
  },
  monthlyTitle: {
    lineHeight: 25,
    marginLeft: 4,
    fontSize: 18.7,
  },
  subheader: { flexDirection: 'row', marginTop: 0, alignItems: 'flex-end' },
});
